const locale = {
  INTRODUCTION: "Introduction",
  INTRODUCTION_CONTENT:
    "The Youth Employment Program is a transformative initiative designed to empower young individuals and equip them with the skills, experience, and opportunities they need to succeed in the workforce. Recognizing the potential of youth as a driving force for economic growth and societal development, this program aims to bridge the gap between education and employment, paving the way for a prosperous future. In todays competitive job market, many young individuals face challenges when trying to enter the workforce due to a lack of experience or skills. The Youth Employment Program addresses these barriers by providing comprehensive support and resources to help participants overcome these obstacles and achieve their career goals. By investing in the development and empowerment of youth, we not only foster their individual success but also contribute to the overall growth and well-being of our communities.",
  PROGRAM_OBJECTIVES: "Program Objectives",
  OBJECTIVE_CONTENT:
    "The Youth Employment Program has three core objectives. Firstly, the program focuses on skill development, offering workshops,training sessions, and hands-on experiences to enhance participants abilities. By equipping them with essential skills such as communication, problem-solving, and teamwork, we enable them to become adaptable and valuable contributors in their chosen fields. Secondly, the program offers participants meaningful work experiences. Through internships, apprenticeships, or summer jobs, participants gain exposure to real-world work environments, allowing them to apply their skills and knowledge in practical settings. These experiences not only build confidence but also foster a strong work ethic and professional network. Lastly, the program provides crucial career guidance and support. Participants are paired with mentors who offer guidance, share their expertise, and assist in navigating the complexities of career planning. Through mentorship, career counseling, and exploration activities, participants gain clarity about their career paths, make informed decisions, and access resources that enable them to pursue their goals effectively.",
  IMPACT: "Impact and Success Stories",
  IMPACT_CONTENT:
    "The Youth Employment Program has witnessed significant impact and success stories. Participants who have completed the program have gone on to secure employment in various industries, pursued higher education, and become leaders in their communities. Their success not only reflects their individual growth but also demonstrates the programs ability to empower youth and unlock their potential. Moreover, the impact extends beyond individual success stories. As participants become productive members of the workforce, they contribute to the economic growth and stability of their regions. The programs emphasis on developing a skilled workforce creates a positive ripple effect, benefiting businesses, communities, and society at large.",
  CONCLUSION: "Conclusion",
  CONCLUSION_CONTENT:
    "The Youth Employment Program is an invaluable investment in the future. By providing young individuals with the skills, experience, and guidance they need, we are nurturing a skilled workforce, fostering economic growth, and creating a brighter future for our communities. Together, we can empower youth and unlock their full potential as they become the architects of a prosperous tomorrow.",

  // Youth Portal Content
  YOUTH: {
    WELCOME_TITLE: "Welcome to CYPMS",
    WELCOME_SUBTITLE: "Your Gateway to Growth",
    WHAT_IS_TITLE: "What Is CYPMS?",
    WHAT_IS_CONTENT_1:
      "The CODICE Youth Program Management System (CYPMS) is a smart, secure, and user-friendly platform designed to support your journey through DC youth employment and development programs—like MBSYEP and more.",
    WHAT_IS_CONTENT_2:
      "Whether you're looking to apply for jobs, track your work hours, or get paid—CYPMS has everything you need in one place.",
    FEATURES_TITLE: "Things You Should Know About CYPMS",
    FEATURES_INTRO: "Here's what you can do once you've registered:",
    FEATURES: {
      ENROLL: {
        TITLE: "Enroll in Programs",
        CONTENT:
          "Apply to youth employment or internship programs directly through the portal.",
      },
      EXPLORE: {
        TITLE: "Explore & Apply for Jobs",
        CONTENT:
          "View open job opportunities, apply with ease, and track your application status.",
      },
      TIMESHEETS: {
        TITLE: "Submit Timesheets",
        CONTENT:
          "Log your work hours daily and view your timesheet history in real time.",
      },
      TRACK_PAY: {
        TITLE: "Track Your Pay",
        CONTENT:
          "See how much you've earned, download pay stubs, and view past salary info.",
      },
      FORMS: {
        TITLE: "Complete Required Forms",
        CONTENT:
          "Fill out and submit your W-4, DC D-4, consent forms, and more—all online.",
      },
      AI_ASSISTANCE: {
        TITLE: "Use AI-Powered Assistance",
        CONTENT:
          "Need help? Our built-in virtual assistant can guide you 24/7 on navigating the platform, writing resumes, or finding matching jobs.",
      },
      ORIENTATION: {
        TITLE: "Complete Orientation & Certification",
        CONTENT:
          "Prepare for your program experience with onboarding tools, quizzes, and learning materials—all within CYPMS.",
      },
      STAY_INFORMED: {
        TITLE: "Stay Informed",
        CONTENT:
          "Receive real-time updates, announcements, and alerts from DOES or your host site via the built-in messaging center.",
      },
    },
    NEXT_STEPS_TITLE: "What Happens After Registration?",
    NEXT_STEPS: [
      "Complete Your Profile – Add your info, education, and interests",
      "Submit Required Documents – Parent consent, proof of residency, tax forms",
      "Take Orientation & Certification Quizzes",
      "Browse & Apply for Jobs",
      "Start Working & Logging Hours",
    ],
  },

  // Host Portal Content
  HOST: {
    WELCOME_TITLE: "Welcome to CYPMS",
    WELCOME_SUBTITLE: "Empowering the Future Workforce",
    WHAT_IS_TITLE: "What Is CYPMS?",
    WHAT_IS_CONTENT_1:
      "The CODICE Youth Program Management System (CYPMS) is a secure and intuitive platform built to help Host Organizations like yours actively engage in DC's youth employment programs—such as MBSYEP and others.",
    WHAT_IS_CONTENT_2:
      "From enrolling your organization to managing worksites, posting job openings, supervising youth, and approving hours—CYPMS brings it all together in one place.",
    FEATURES_TITLE: "Things You Should Know About CYPMS",
    FEATURES_INTRO:
      "Here's what you can do once your organization is registered:",
    FEATURES: {
      ENROLL: {
        TITLE: "Enroll Your Organization in a Program",
        CONTENT:
          "Sign up to participate in youth employment programs and manage your involvement each year.",
      },
      WORKSITES: {
        TITLE: "Set Up Worksites and Teams",
        CONTENT:
          "Create and manage worksites, add supervisors, and define roles and capacities for each location.",
      },
      POST_JOBS: {
        TITLE: "Post Job Openings",
        CONTENT:
          "Publish internship or employment opportunities for youth. You can even use our AI-powered assistant to generate job advertisements based on your prompt.",
      },
      APPLICATIONS: {
        TITLE: "View and Manage Job Applications",
        CONTENT:
          "See who's applied for your posted jobs and make informed selections based on application details.",
      },
      SUPERVISE: {
        TITLE: "Assign and Supervise Youth",
        CONTENT:
          "Supervisors can oversee youth performance, log feedback, and support their learning experience.",
      },
      APPROVE_TIMESHEETS: {
        TITLE: "Approve Timesheets",
        CONTENT:
          "Review and approve youth-submitted timesheets directly through the portal—ensuring accurate and timely payroll processing.",
      },
      PROGRAM_FORMS: {
        TITLE: "Submit Program Forms",
        CONTENT:
          "Report incidents, request transfers, or submit terminations through streamlined online forms.",
      },
      NOTIFICATIONS: {
        TITLE: "Receive Real-Time Notifications",
        CONTENT:
          "Stay updated with system messages, alerts, and important reminders from DOES.",
      },
    },
    NEXT_STEPS_TITLE: "What Happens After Registration?",
    NEXT_STEPS: [
      "Complete Your Organization Profile – Add your team, roles, and contact details",
      "Enroll in a Program – Confirm your interest in MBSYEP or similar initiatives",
      "Create Worksites & Assign Supervisors – Organize how youth will be hosted",
      "Publish Job Openings – List available roles and review applications",
      "Approve Timesheets and Monitor Youth – Manage youth participation and engagement",
    ],
  },

  // Admin Portal Content
  ADMIN: {
    WELCOME_TITLE: "Welcome to the CYPMS Admin Portal",
    WELCOME_SUBTITLE: "Powering Program Management",
    WHAT_IS_TITLE: "What Is CYPMS?",
    WHAT_IS_CONTENT_1:
      "The CODICE Youth Program Management System (CYPMS) is a modern, secure platform that equips DC government staff with the tools to manage, oversee, and optimize youth employment programs like MBSYEP and beyond.",
    WHAT_IS_CONTENT_2:
      "Whether you're tracking registrations, approving documents, managing payroll files, or extracting reports — the Admin Portal provides everything in one integrated environment.",
    FEATURES_TITLE: "Things You Should Know About CYPMS",
    FEATURES_INTRO: "Here's what you can do once logged into the Admin Portal:",
    FEATURES: {
      DASHBOARD: {
        TITLE: "Monitor Program Activity via Dashboard",
        CONTENT:
          "Access real-time data on youth registrations, host enrollments, pending approvals, timesheet statuses, and more—all in one snapshot.",
      },
      DOCUMENTATION: {
        TITLE: "Review and Approve Documentation",
        CONTENT:
          "Approve or reject documents submitted by youth and hosts including consent forms, proof of eligibility, W-4/D-4 forms, transfer and termination requests.",
      },
      PAYROLL: {
        TITLE: "Manage Payroll Submission",
        CONTENT:
          "Compile and submit approved timesheet data to payroll processors like Paycor/ADP and prepare compliant files for submission to the District's financial system (DIFS).",
      },
      REPORTS: {
        TITLE: "Access and Export Reports",
        CONTENT:
          "Generate detailed reports on participation, jobs, payroll, and compliance. Use filters to drill down into trends and export data for analysis or auditing.",
      },
      PROFILES: {
        TITLE: "View Youth and Host Profiles",
        CONTENT:
          "Search and view comprehensive records of both youth participants and host organizations, including submitted forms, activity history, and approval status.",
      },
      ONBOARDING: {
        TITLE: "Create and Manage Onboarding Tools",
        CONTENT:
          "Build Orientation, Banking, and Certification quizzes that youth complete during registration and onboarding.",
      },
      USERS: {
        TITLE: "Create and Manage Admin Users",
        CONTENT:
          "Add new admin users, assign roles and permissions, and control access to specific system features.",
      },
      COMMUNICATIONS: {
        TITLE: "Send Communications",
        CONTENT:
          "Broadcast announcements, alerts, and instructions to youth, hosts, or other admins using the integrated messaging system.",
      },
      SSO: {
        TITLE: "Login via Active Directory / OKTA",
        CONTENT:
          "DOES Admins can log in using secure Single Sign-On via Active Directory or OKTA, ensuring centralized and secure authentication.",
      },
    },
    NEXT_STEPS_TITLE: "What Happens After Login?",
    NEXT_STEPS: [
      "Monitor Key Activity – Use the dashboard to track system-wide progress",
      "Review Approvals – Process forms, verify documents, and manage exceptions",
      "Manage Payroll and Reporting – Submit, track, and verify payroll data",
      "Support System Operations – Create users, programs, quizzes, and more",
      "Communicate Efficiently – Keep stakeholders informed with timely messages",
    ],
  },

  // Parent Portal Content
  PARENT: {
    WELCOME_TITLE: "Welcome to the CYPMS Parent Portal",
    WELCOME_SUBTITLE: "Stay Connected, Stay Informed",
    WHAT_IS_TITLE: "What Is CYPMS?",
    WHAT_IS_CONTENT_1:
      "The CODICE Youth Program Management System (CYPMS) is a centralized digital platform that supports DC's youth employment initiatives like MBSYEP. The Parent Portal gives guardians secure access to monitor and support their child's participation in these programs.",
    WHAT_IS_CONTENT_2:
      "From approving consent forms to viewing work history and receiving important updates—CYPMS ensures you stay connected to your child's progress every step of the way.",
    FEATURES_TITLE: "Things You Should Know About CYPMS",
    FEATURES_INTRO: "Here's what you can do once you're invited and logged in:",
    FEATURES: {
      CONSENT: {
        TITLE: "Approve Parental Consent Requests",
        CONTENT:
          "Easily approve or decline parental consent forms submitted by your child as part of their program enrollment.",
      },
      PROFILES: {
        TITLE: "View Linked Youth Profiles",
        CONTENT:
          "See a list of all children who have identified you as their parent or guardian, with access to their program participation details.",
      },
      ENROLLMENT: {
        TITLE: "Track Enrollment Status",
        CONTENT:
          "Follow your child's enrollment progress, including completion of tax forms, orientation, and certification quizzes.",
      },
      TIMESHEETS: {
        TITLE: "View Timesheet and Attendance",
        CONTENT:
          "Monitor your child's logged hours, attendance, and timesheet submission status across program weeks.",
      },
      PAYMENT: {
        TITLE: "View Payment History",
        CONTENT:
          "Access summaries of your child's earnings, pay periods, and payment dates—helping you guide their financial understanding.",
      },
      NOTIFICATIONS: {
        TITLE: "Receive Notifications and Alerts",
        CONTENT:
          "Stay informed with real-time updates from DOES, program staff, or hosts regarding job assignments, issues, or upcoming events.",
      },
      ASSISTANT: {
        TITLE: "Use AI Assistant for Support",
        CONTENT:
          "Have a question about the program, documents, or timelines? Ask our virtual assistant for instant guidance—available 24/7.",
      },
      SECURITY: {
        TITLE: "Secure Account Access",
        CONTENT:
          "Your account is protected by multi-step authentication, ensuring your family's information stays safe and confidential.",
      },
    },
    NEXT_STEPS_TITLE: "What Happens After Your Child Registers?",
    NEXT_STEPS: [
      "You'll receive an email invitation to create your CYPMS account",
      "Log in to approve the parental consent form",
      "Monitor their progress through orientation, onboarding, and placement",
      "View timesheets and pay details as the program begins",
      "Stay involved with updates, messages, and support tools",
    ],
  },

  // Common elements
  COMMON: {
    BANNER_ALT_TEXT: {
      YOUTH: "Youth Portal",
      HOST: "Host Portal",
      ADMIN: "Admin Portal",
      PARENT: "Parent Portal",
    },
  },
};

export default locale;
